import Vue from "vue";
import Scrolly from "./Scrolly.vue";
import ScrollyViewport from "./ScrollyViewport.vue";
import ScrollyBar from "./ScrollyBar.vue";

export { Scrolly, ScrollyViewport, ScrollyBar };

Vue.component("scrolly", Scrolly);
Vue.component("scrolly-viewport", ScrollyViewport);
Vue.component("scrolly-bar", ScrollyBar);
